import React,{useState, useEffect} from "react";
import "./CardIconRow.css"; // Make sure to include styles here or inline as needed

const cards = [
  {
    src: "/new-img/cards/visa.svg",
    alt: "VISA",
  },
  {
    src: "/new-img/cards/mastercard.svg",
    alt: "MASTERCARD",
  },
  {
    src: "/new-img/cards/amex.svg",
    alt: "AMEX",
  },
  {
    src: "/new-img/cards/discover.svg",
    alt: "DISCOVER",
  },
  {
    src: "/new-img/cards/jcb.svg",
    alt: "JCB",
  },
  {
    src: "/new-img/cards/diners_club.svg",
    alt: "DINERS",
  },
  {
    src: "/new-img/cards/unionpay.svg",
    alt: "UNIONPAY",
  },
  {
    src: "/new-img/cards/elo.svg",
    alt: "ELO",
  },
];
function getMatchingCard(keyword: string) {
  return cards.find((card) => card.alt === keyword);
}

interface Props {
    cardType: any;
}
const CardIconsRow: React.FC<Props> = ({ cardType }) => {
  const [uniqueCard, setUniqueCard] = useState<any>({})
  useEffect(()=>{
    setUniqueCard(getMatchingCard(cardType))
  }, [cardType])

  const isSmallScreen = window.innerWidth < 500;
  const maxVisible = isSmallScreen ? 3 : 4;

  const visibleCards = cards.slice(0, maxVisible);
  const hiddenCards = cards.slice(maxVisible);



  return (
    <div className="card-icons-wrapper">
      {
        uniqueCard
        ?
        <img src={uniqueCard.src} alt={uniqueCard.alt} className="card-icon" />
        :
        <>
          {visibleCards.map((card, idx) => (
              <img key={idx} src={card.src} alt={card.alt} className="card-icon" />
            ))}

            {hiddenCards.length > 0 && (
              <div className="more-cards-hover-wrapper">
                <div className="more-cards-button">
                  +{hiddenCards.length}
                </div>
                <div className="more-cards-tooltip">
                  {hiddenCards.map((card, idx) => (
                    <img
                      key={idx}
                      src={card.src}
                      alt={card.alt}
                      className="card-icon"
                    />
                  ))}
                </div>
            </div>
          )}
        </>
      }
      
    </div>
  );
};

export default CardIconsRow;
